import React, { useState, useEffect } from 'react'

import {
  View,
  Text,
  Button,
  TouchableOpacity,
  StyleSheet,
  FlatList
} from 'react-native'

// import { useNavigation } from '@react-navigation/native';

// import { LanguageContext } from './LanguageContext';

// import BasicInformationForm from '../../components/home/forms/BasicInformationForm';

import i18next from '../../i18n/i18next'

import { useTranslation } from 'react-i18next'

import { globalStyles, fontPalette } from '../../static/styles/global'

import { AntDesign } from '@expo/vector-icons'

import SelectDropdown from 'react-native-select-dropdown'
import { useNavigation } from '@react-navigation/native'

import { useNavigationState } from '@react-navigation/native'
//async
import AsyncStorage from '@react-native-async-storage/async-storage'
import { useHomeStore } from '../../stores/home'

const togglelanguage = () => {
  const currentLanguage = i18next.language

  const newlanguage = currentLanguage === 'English' ? 'Spanish' : 'English'

  i18next.changeLanguage(newlanguage)
}

const countries = ['English', 'Spanish']

const LanguageSelectionScreen = () => {
  const navigation = useNavigation()
  const [isOpen, setIsOpen] = useState(false)
  const { setLanguage } = useHomeStore()
  const [selectedOption, setSelectedOption] = useState('English')
  const { t, i18n } = useTranslation()

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }
  useEffect(() => {
    if (i18n.language) {
      setSelectedOption(i18n.language === 'SPA' ? 'Spanish' : 'English')
    }
  }, [i18n.language])

  const options = ['English', 'Spanish']
  const routes = useNavigationState((state) => state.routes)
  const currentRoute = routes[routes.length - 3].name

  const handleOptionClick = async (option) => {
    setSelectedOption(option)

    setIsOpen(false)
    let selectedLanguageCode = 'ENG' // Default to English
    if (option === 'Spanish') {
      selectedLanguageCode = 'SPA'
      setLanguage('SPA')
    } else {
      setLanguage('ENG')
    }

    // Store the selected language in AsyncStorage
    await AsyncStorage.setItem('selectedLanguage', selectedLanguageCode)

    // Change the language in i18next
    i18next.changeLanguage(selectedLanguageCode)

    // Navigate to the current route
    navigation.navigate(currentRoute)
  }

  const [isDropdownOpen, setIsDropdownOpen] = useState(false)


  const changeLanguage = (newLanguage) => {
    i18next.changeLanguage(newLanguage)
  }

  return (
    <View style={[globalStyles.container]}>
      {/* <View >

<TouchableOpacity onPress={togglelanguage}>

<Text style={{}}>{("change-language")}</Text>

</TouchableOpacity>

<View style={{}}>

<SelectDropdown

data={countries}

  onSelect={(selectedItem, index) => {

  i18next.changeLanguage(selectedItem)

  }}/>

  </View>

</View> */}

      <View>
        <Text
          style={{
            fontSize: 24,
            fontFamily: fontPalette.primaryBold,
            alignSelf: 'center',
            margin: 24
          }}
        >
          {t('changelanguage')}
        </Text>

        <TouchableOpacity onPress={toggleDropdown}>
          <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
            <Text>{i18next.language}</Text>

            <AntDesign name="caretdown" size={19} color="black" />
          </View>
        </TouchableOpacity>

        {isOpen && (
          <View style={styles.dropdownOptions}>
            <FlatList
              data={options}
              keyExtractor={(item) => item}
              renderItem={({ item }) => (
                <TouchableOpacity onPress={() => handleOptionClick(item)}>
                  <View style={styles.optionItem}>
                    <Text>{item}</Text>
                    <RadioButtons selected={selectedOption === item} />
                  </View>
                </TouchableOpacity>
              )}
            />
          </View>
        )}
      </View>
    </View>
  )
}

const RadioButtons = ({ selected }) => (
  <View style={[styles.radioButton, selected && styles.selectedRadioButton]} />
)

const styles = StyleSheet.create({
  appBrand: { width: 90, height: 90 },

  fmsBrand: { width: 40, height: 40 },

  dropdownOptions: {
    width: 145,

    alignSelf: 'center',

    marginTop: 10,

    borderWidth: 1,

    borderColor: '#ccc',

    padding: 10
  },

  optionItem: {
    flexDirection: 'row',

    alignItems: 'center',

    justifyContent: 'space-between',

    padding: 5
  },

  radioButton: {
    width: 20,

    height: 20,

    borderRadius: 10,

    borderWidth: 2,

    borderColor: 'black'
  },

  selectedRadioButton: {
    backgroundColor: '#0B495C'
  }
})

export default LanguageSelectionScreen
